import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root",
})
export class CustomCookieService {
  constructor(private readonly _cookieService: CookieService) {}

  get(cookieName: CookieName) {
    const cookieValue = this._cookieService.get(cookieName);

    /**
     * Unfortunately, the external package returns an empty string for a cookie key which can not be found.
     */
    return cookieValue === "" ? undefined : cookieValue;
  }
}

export enum CookieName {
  // Pax Portal
  CAMPAIGN_URL = "__gtm_campaign_url",
  REFERRER = "__gtm_referrer",
}
